<!-- loading -->
<vl-region v-if="isLoading">
    <vl-layout>
        <div v-vl-align:center>
            <vl-loader message="De gegevens worden geladen. Even geduld, a.u.b."/>
        </div>
    </vl-layout>
</vl-region>
<!-- ./loading -->
<vl-region v-else>
    <vl-form-grid mod-stacked>
        <vl-column>
            <vl-typography>
                Organisaties die gebruikmaken van een <strong>‘Factuurreferentie’</strong> bij de facturatiegegevens ontvangen <strong>elke 25ste van de maand</strong> een e-mail  met het verzoek deze gegevens te controleren en indien nodig aan te passen vóór de 6de van de volgende maand.
                Dit veld kan bijvoorbeeld een bestelbon- of PO-nummer bevatten. De facturen worden op de 6de van de maand verzonden via Peppol of per e-mail. Voor vragen kunt u contact opnemen via <vl-link :href="helpdeskMail">{{helpdeskMail}}</vl-link>.
            </vl-typography>
        </vl-column>
        <vl-column width="12"></vl-column>
        <vl-column>
            <kl-contact-card :title="organisationDisplayName" :subtitle="organisationVatNumber"
                             :address="!organisationInvoiceSettings.isAthumiGatewayServiceUnavailable ? organisationAddress : null"
                             :email="organisationEmail" />
            <template v-if="!hasSubOrganisations">
                <br />
                <p v-if="organisationInvoiceSettings.attention">
                    <span v-vl-text.light>Ter attentie van:</span> {{ organisationInvoiceSettings.attention }}
                </p>
                <p v-if="organisationInvoiceSettings.reference">
                    <span v-vl-text.light>Factuurreferentie:</span> {{ organisationInvoiceSettings.reference }}
                </p>
                <p v-if="organisationInvoiceSettings.attention">
                    <span v-vl-text.light>E-mailadres voor factuurherinneringen:</span> {{ organisationInvoiceSettings.reminderEmail }}
                </p>
            </template>
        </vl-column>
        <vl-action-group>
            <vl-button tag-name="a" @click="updateOrganisationInvoiceSettings(organisationInvoiceSettings)" mod-link>
                Aanpassen
            </vl-button>
        </vl-action-group>
        <template v-if="hasSubOrganisations">
            <vl-column width="12"></vl-column>
            <vl-column>
                <kl-invoice-group-edit :disable-create-button="subOrganisationsInvoiceSetting.length <= 0"
                                       :disabled-organisations="organisationsAlreadyInGroup"
                                       :invoice-group="organisationInvoiceGroupToUpdate"
                                       :sub-organisations="subOrganisations"
                                       @on-cancel="cancelOrganisationInvoiceGroup"
                                       @on-save="saveOrganisationInvoiceGroup" />
            </vl-column>
            <vl-column width="12" v-for="group in organisationInvoiceGroups" :key="group.id" >
                <kl-invoice-group-card :group="group" @on-delete="showDeleteOrganisationInvoiceGroupModal" @on-update="updateOrganisationInvoiceGroup" />
            </vl-column>
            <vl-column width="12"></vl-column>
            <template v-if="subOrganisationsInvoiceSetting.length >= 1">
                <vl-column width="12">
                    <vl-title tag-name="h4">Organisaties met afzonderlijke factuur</vl-title>
                </vl-column>
                <vl-column width="6" v-for="(invoiceSetting, index) in subOrganisationsInvoiceSetting" :key="index" >
                    <kl-invoice-setting-card :invoice-setting="invoiceSetting" @on-update="updateSubOrganisationInvoiceSettings" />
                </vl-column>
            </template>
        </template>
    </vl-form-grid>

    <kl-invoice-setting-edit :show-address-info="showAddress"
                             :show-extra-info="showExtraInfo"
                             :invoice-setting="organisationInvoiceSettingToUpdate"
                             @on-save="saveOrganisationInvoiceSettings" />

    <vl-modal id="delete-invoice-group" :closable="true">
        <vl-title tag-name="h3">Bent u zeker dat u deze facturatiegroep wil verwijderen?</vl-title>
        <vl-typography>
            Dit kan niet ongedaan worden gemaakt.
        </vl-typography>
        <vl-action-group>
            <vl-button @click="deleteOrganisationInvoiceGroup" mod-large mod-error :mod-loading="deletingOrganisationInvoiceGroup"
                       :mod-disabled="deletingOrganisationInvoiceGroup">Ja, verwijder facturatiegroep</vl-button>
            <vl-button type="button" mod-link @click="cancelDeleteOrganisationInvoiceGroup" icon="cross" mod-icon-before>
                Annuleer</vl-button>
        </vl-action-group>
    </vl-modal>
</vl-region>

